<h2 mat-dialog-title class="treeslo-modal-header">
    <span class="treeslo-modal-header__title">{{ "modals.date_range_modal.title" | translate }}</span>
    <button type="button" mat-icon-button class="treeslo-modal-header__close" mat-dialog-close
        [attr.aria-label]="'common.close' | translate">
        <mat-icon>close</mat-icon>
    </button>
</h2>

<mat-dialog-content>
    <form [formGroup]="form" class="treeslo-modal-form">
        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ "modals.date_range_modal.start_Date_Placeholder" | translate }}</mat-label>
            <input matInput [matDatepicker]="startPicker" formControlName="start" [min]="data.minDate"
                [max]="data.maxDate" />
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
            <mat-error *ngIf="form.get('start')?.hasError('required')">
                {{ "common.required" | translate }}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
            <mat-label>{{ "modals.date_range_modal.end_Date_Placeholder" | translate }}</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="end" [min]="data.minDate"
                [max]="data.maxDate" />
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
            <mat-error *ngIf="form.get('end')?.hasError('required')">
                {{ "common.required" | translate }}
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="treeslo-modal-actions">
        <button mat-stroked-button type="button" (click)="onCancel()">
            {{ "modals.date_range_modal.cancel" | translate }}
        </button>
        <button mat-flat-button color="primary" type="button" (click)="onSave()" [disabled]="!form.valid">
            {{ "modals.date_range_modal.apply" | translate }}
        </button>
    </div>
</mat-dialog-actions>
